<template>
  <div class="store_blocks">
    <div v-html="getStoreInfoByStore($AllCities[order.city_id] && $AllCities[order.city_id].store.store_id)"
         class="selected_store"/>
    <template v-if="$AllCities[order.city_id]">
      <template v-for="(storeId, index) in $StoreRelations[$AllCities[order.city_id].store.store_id]">
        <div
          v-html="getStoreInfoByStore(storeId, index === 0 ? $AllDivisions[order.division_id].stores[0].object_id : $StoreRelations[$AllCities[order.city_id].store.store_id][(index-1)])"/>
      </template>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['storeInfo', 'order', 'drug'],
  computed: {
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  data() {
    return {
      localStoreData: {},
    }
  },
  created() {
    this.updateStoreData()
  },
  methods: {
    getStoreInfoByStore(storeId, exclude = null) {
      if (!storeId) return 0;
      let qty;
      if (!exclude) {
        // console.log(this.storeInfo.inStores[storeId], this.order.id, (this.storeInfo.requests[storeId] && this.storeInfo.requests[storeId][1] && this.storeInfo.requests[storeId][1].ordersQty && this.storeInfo.requests[storeId][1].ordersQty[this.order.id] || 0))
        // qty = this.storeInfo.inStores[storeId] + (this.storeInfo.requests[storeId] && this.storeInfo.requests[storeId][1] && this.storeInfo.requests[storeId][1].ordersQty && this.storeInfo.requests[storeId][1].ordersQty[this.order.id] || 0)
        qty = this.storeInfo.inStores[storeId] || 0;
      } else {
        const stores = this.getRelatedRequestsByStoreId(storeId, exclude)
        // console.log(storeId, exclude, stores);
        qty = (this.localStoreData.clearedStore[storeId] || 0) - (this.localStoreData.storesRequests[storeId] || 0)
        stores.forEach((sId) => {
          qty -= +(this.localStoreData.storesRequests[sId] || 0)
        })
      }
      // console.log(qty);
      let transitQty = 0
      let transitDate = moment()
      if (this.storeInfo.transitDetails && this.storeInfo.transitDetails[storeId] && this.storeInfo.transitDetails[storeId].details_in) {
        this.storeInfo.transitDetails[storeId].details_in.forEach((t) => {
          transitQty += t.qty
          if (transitDate < moment(t.date)) {
            transitDate = moment(t.date)
          }
        })
      }
      return this.$AllStores[storeId].short_title + ': <strong>' + (qty + transitQty) + '</strong>'
        + (transitQty ? ' из них на складе <strong>' + qty + '</strong> в дороге <strong>' + transitQty
          + '</strong> (поступление ' + transitDate.format('DD.MM') + ')' : '')
    },
    getRelatedRequestsByStoreId(storeId, exclude, index = 0, sortedStores = []) {
      const stores = Object.values(this.$AllStores).filter((s) => s.parent_id === +storeId)
      stores.forEach((s) => {
        if (exclude != s.id) {
          sortedStores = this.getRelatedRequestsByStoreId(s.id, exclude, 1, sortedStores)
        }
      })
      if (index) {
        sortedStores.push(storeId)
      }
      return sortedStores
    },
    updateStoreData() {
      const localStoreData = {
        inStore: {...this.storeInfo.actualStoreData},
        clearedStore: {},
        storesRequests: {},
        relatedRequests: {},
      }
      Object.keys(this.storeInfo.transitDetails || {}).forEach((storeId) => {
        if (this.storeInfo.transitDetails[storeId].out) {
          if (!localStoreData.inStore[storeId]) {
            localStoreData.inStore[storeId] = 0
          }
          localStoreData.inStore[storeId] -= this.storeInfo.transitDetails[storeId].out
        }
      })

      Object.keys(this.$AllStores).forEach((sId) => {
        let re = (localStoreData.inStore && localStoreData.inStore[sId] || 0)
        Object.values(this.storeInfo.requests && this.storeInfo.requests[sId] || {}).forEach((rr) => {
          Object.keys(rr.ordersQty).forEach((oId) => {
            if (this.order && this.order.id !== +oId) {
              re -= +rr.ordersQty[oId]
              // re -= rr.qty;
            }
          })
        })

        if (this.storeInfo.transitDetails && this.storeInfo.transitDetails[sId] && this.storeInfo.transitDetails[sId].in) {
          re += this.storeInfo.transitDetails[sId].in
        }

        if (re < 0) {
          localStoreData.clearedStore[sId] = 0
          localStoreData.storesRequests[sId] = Math.abs(re)
        } else {
          localStoreData.clearedStore[sId] = re
        }
      })
      this.localStoreData = localStoreData
    }
  }
}
</script>
<style scoped>
.store_blocks {
  display: flex;
  flex-wrap: wrap;
}

.store_blocks .selected_store {
  border: 3px solid gray;
}

.store_blocks div {
  padding: 0 5px;
  border: 2px solid lightgray;
  margin-right: 3px;
}
</style>
